import { goBack as back, closeWebView } from '@/api/native/utils';
import router from '@/router';

import _ from 'lodash';
import wechat from '@/api/native/wechat';
import platform from '../platform';

export const goBack = (n = -1): void => {
  if (platform.isHelloApp && (platform.isAndroid || platform.isHarmony)) {
    _.times(-n, back);
  } else {
    router.go(n);
  }
};

/** 离开臻有钱首页 */
export const leaveHomeWebview = (): void => {
  /** TODO: 后续需要判断history.length，避免遇到别的页面跳转我们页面的场景 把整个WebView */
  if (platform.isHelloApp) {
    closeWebView();
  } else if (platform.isWechatMini) {
    wechat.navigateBack();
  } else {
    window.history.go(-2);
  }
};

/**
 * 返回上一页
 * 微信小程序且历史记录长度为1时，使用微信小程序的返回方法
 * 否则使用 Vue Router 的返回方法
 */
export const goBackPreviousPage = (forceCloseWebView = false): void => {
  if (platform.isWechatMini && window.history.length === 1) {
    wechat.navigateBack();
  } else if (platform.isHelloApp && (window.history.length === 1 || forceCloseWebView)) {
    closeWebView();
  } else {
    window.history.go(-1);
  }
};
